/*** IMPORTS FROM imports-loader ***/


module.exports = {
    title: "40 Thieves",
    theme: "40t",
    baseMultiplier: 1,
    maxPrize: 9,

    font: "ProximaNova",
    fontVariations: ":n4,n7",
    secondaryFont: "SignPainter",

    hasButtonImage: true,
    blurMenuBg: true,
    bigWinStartingPrizeId: 3,

    backgroundAnchorX: 0.5,
    backgroundAnchorY: 0.9,

    donePercent: 60,
    brushSize: 100,
    scratchY: 20,
    prizeTextY: 40,
    prizeScale: 0.8,

    showLogoInGame: false,
    logoYTitle: 80,
    logoZTitle: 0,
    logoFromBottomTitle: false,

    showCharacter: true,
    characterX: -150,
    characterY: 400,
    characterZ: 1,

    showFog: false,
    showBottomGradient: false,

    ticketIdX: -12,

    titleLossY: 190,

    winSign: 'movie',
    winSignTextY: 45,
    winSignTextMaxWidth: 220,
    winSignTextMaxFontSize: 50,
    winSignYOffset: 20,

    bgColor: 0x0d3860,
    primaryColor: 0xfcb62e,

    images: {

        brush: "brush.png",

        bgs: {
            scratched: "scratch_bg.png",
            unscratched: "scratch.png"
        },

        prizes: {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9"
        },
    },

    sounds: {
        volumes: {
            click: 0.3,
            music: 0.08,
            reveal: 0.5,
            bigWin: 0.4,
            win: 0.4,
            loss: 0.4
        },
        prizes: {
            1: "win-2",
            2: "win-3",
            3: "win-3",
            4: "win-3",
            5: "win-4",
            6: "win-4",
            7: "win-4",
            8: "win-4",
            9: "win-4"
        }
    },

    styles: {
        prize: {
            fontFamily: "ProximaNova",
            fontSize: 17,
            fontWeight: 100,
            fill: "#FEE9FF",
            align: "center",
            lineHeight: 25,
            stroke: '#0F0E33',
            strokeThickness: 2,
            dropShadow: true ,
            dropShadowColor: '#000000',
            dropShadowAngle: Math.PI/2 ,
            dropShadowDistance: 1
        },
        maxPrize: {
            fontFamily: "ProximaNova",
            fontSize: 17,
            fontWeight: 100,
            fill: "#D9C82C",
            align: "center",
            lineHeight: 25,
            stroke: '#0F0E33',
            strokeThickness: 2,
            dropShadow: true ,
            dropShadowColor: '#000000',
            dropShadowAngle: Math.PI/2 ,
            dropShadowDistance: 1
        },
        introText: {
            fontFamily: "ProximaNova",
            fontSize: 16,
            fontWeight: 100,
            fill: "#FFFFFF",
            align: "center",
            lineHeight: 23,
            wordWrap: true,
            wordWrapWidth: 260,
            stroke: '#00204e',
            strokeThickness: 3,
            lineJoin: 'round',
            dropShadow: false,
            dropShadowBlur: 3,
            dropShadowColor: '#000000',
            dropShadowAngle: Math.PI/2,
            dropShadowDistance: 2
        }
    },

    positions: {
        points:[
            {
                x:0.22,
                y:0.26
            },
            {
                x:0.50,
                y:0.26
            },
            {
                x:0.78,
                y:0.26
            },
            {
                x:0.22,
                y:0.52
            },
            {
                x:0.50,
                y:0.52
            },
            {
                x:0.78,
                y:0.52
            },
            {
                x:0.22,
                y:0.78
            },
            {
                x:0.50,
                y:0.78
            },
            {
                x:0.78,
                y:0.78
            }
        ]
    }
};



//////////////////
// WEBPACK FOOTER
// ./themes/40t/config.js
// module id = 50
// module chunks = 4